import { calculateDefaultCourse, getActiveOffersByPriority } from '../helpers/enrolment'
import { getPreferredCourse, updatePreferredCourse } from '../services/vu'
import {setCourse, fetchRequiredCourse, fetchAndUpdatePreferredCourse} from './course'

export const fetchDefaultCourse = (courseIdFromQueryParam = null) => {
  return (dispatch, getState) => {
    dispatch(requestDefaultCourse())

    return dispatch(fetchCoursesIfNeeded()).then(() => {
      return getPreferredCourse().then(({ courseId }) => {
        let courseCode = courseId
        const {
          courses: { data: courses }
        } = getState()

        const defaultCourse = calculateDefaultCourse(courseIdFromQueryParam, courseCode, courses)

        let course = courses[defaultCourse]

        // Save the "active" course to the API
        if (defaultCourse && defaultCourse !== courseCode) {
          dispatch(fetchAndUpdatePreferredCourse(course, false))
        } else {
          dispatch(selectCourse(defaultCourse))
        }

        return dispatch(setCourse(course))
        //return dispatch(fetchRequiredCourse(course))
      })
    })
  }
}

// export const fetchAndUpdatePreferredCourse = courseCode => {
//   return dispatch => {
//     return updatePreferredCourse(courseCode).then(() => {
//       return dispatch(selectCourse(courseCode))
//     })
//   }
// }

export const fetchCoursesIfNeeded = () => {
  return (dispatch, getState) => {
    if (shouldFetchCourses(getState())) {
      return dispatch(fetchCourses())
    }
    return Promise.resolve()
  }
}

export const generateFakeCourse = course => {
  return dispatch => {
    dispatch(requestCourses())
    dispatch(receiveCourses([course]))
    dispatch(selectCourse(course.courseCode))

    return Promise.resolve()
  }
}

const shouldFetchCourses = state => {
  return !state.courses.data
}

export const fetchCourses = () => {
  return dispatch => {
    dispatch(requestCourses())

    return getActiveOffersByPriority().then((courses = []) => {
      return dispatch(receiveCourses(courses))
    })
  }
}

const requestDefaultCourse = () => {
  return {
    type: 'REQUEST_DEFAULT_COURSE'
  }
}

const selectCourse = courseCode => {
  return {
    type: 'SELECT_COURSE',
    courseCode
  }
}

const requestCourses = () => {
  return {
    type: 'REQUEST_COURSES'
  }
}

const receiveCourses = (courses = []) => {
  return {
    type: 'RECEIVE_COURSES',
    courses
  }
}
